<template>
    <div>
        <b-row>
            <b-col>
                <p>{{ $t('Page(ReceivedRequest):Component(Instruction):send-reply-to-customer') }}</p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="text-muted text-center">

                </div>
                <div class="text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        @click="send"
                    >
                        {{ $t('Component(Button):send-reply') }}
                    </b-button>
                    <span v-if="isReplyDetailsVisible">
                        {{ $t('Page(ReceivedRequest):Component(Text):last-reply-date', {date: renderDate(replyDetails.sentAt), time: renderTime(replyDetails.sentAt)}) }}
                    </span>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {BButton, BCol, BRow} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import dateRenderer from "@core/mixins/date-renderer";

export default {
    mixins: [dateRenderer],
    directives: {Ripple},
    components: {
        BButton, BCol, BRow
    },
    props: {
        replyDetails: {
            default() {
                return null;
            }
        }
    },
    methods: {
        send() {
            this.$emit('send');
        }
    },
    computed: {
        isReplyDetailsVisible() {
            return this.replyDetails && null !== this.replyDetails.sentAt;
        }
    }
}
</script>
